import ContinueShopping from '@mvps-genesis/continue-shopping';
import CookieJar from '@mvps-genesis/cookie-jar';
import dynamicFormElementAttributes from '@mvps-genesis/dynamic-form-element-attributes';
import EventBus from '@mvps-genesis/event-bus';
import 'construct-style-sheets-polyfill';
import 'element-internals-polyfill';
import BuilderOrder from 'extensions/builder-order/BuilderOrder';
import HTMLFormValidatorScrollTop from 'extensions/form-validation/HTMLFormValidatorScrollTop';
import MiniBasket from 'extensions/mini-basket/main.js';
import NavigationMenu from 'extensions/navigation-menu';
import SearchFieldExtended from 'extensions/search-field-extended/search-field-extended.js';
import 'extensions/sticky-account-header/sticky-account-header.js';
import 'extensions/sticky-global-header/sticky-global-header.js';
import WarrantyProcess from 'extensions/warranty-checkout/WarrantyProcess';
import {PageManager} from 'genesis-packages/core';
import {GlobalMessageContainer} from 'genesis-packages/messages';
import Inputmask from 'inputmask';
import './Global.scss';

export default class Global extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		/**
		 * Micro Modal
		 */
		this.initModals();

	}

	// eslint-disable-next-line class-methods-use-this, max-lines-per-function
	onReady () {

		if (window.navigator.userAgent.match(/(MSIE|Trident)/)) {
			document.body.classList.add('is-ie');
		}

		const mainMenuElem = document.querySelector('.js-navigation-menu');
		if (mainMenuElem) {
			new NavigationMenu({
				drawers: '.js-navigation-menu__drawer',
				mainMenu: mainMenuElem,
				mainMenuCloseButtons: '.js-navigation-menu__close',
				mainMenuOpenButtons: '.js-navigation-menu__open',
				menuItems: '.js-navigation-menu__link',
				parentMenus: '.js-navigation-menu__has-child',
				showPreviousMenuButtons: '.js-navigation-menu__previous'
			});
		}

		EventBus.addEventListener('MVPS:addToCart', (event) => this.addedToCart(event), false);

		/**
		 * Toggle the `is-open` state of the global account box.
		 */
		(function () {
			var trigger = document.querySelector('[data-hook="show-related"]');

			if (trigger) {
				var relatedTarget = document.querySelector('[data-hook="' + trigger.getAttribute('data-target') + '"]');

				trigger.addEventListener('click', function (event) {
					event.preventDefault();
					relatedTarget.classList.toggle('is-open');
				}, false);

				document.addEventListener('mousedown', function (event) {
					if (relatedTarget.classList.contains('is-open')) {
						if (!relatedTarget.contains(event.target) && event.target !== trigger) {
							relatedTarget.classList.toggle('is-open');
							event.preventDefault();
						}
					}
				}, false);

				window.addEventListener('keydown', function (event) {
					if (event.defaultPrevented) {
						return;
					}

					switch (event.key) {
						case 'Escape':
							if (relatedTarget.classList.contains('is-open')) {
								relatedTarget.classList.toggle('is-open');
							}
							break;
						default:
							return;
					}

					event.preventDefault();
				}, true);
			}
		}());

		/**
		 * Initialize Extended Search Field
		 */
		new SearchFieldExtended();

		if (this.pageContext.Customer_Login) {

			/**
			 * Warranty Process
			 */
			new WarrantyProcess(this.pageContext.API_Url, this.pageContext.Basket_Url);

			/**
			 * Builder Order
			 */
			new BuilderOrder();
		}

		/**
		 * Initialize continue shopping link
		 */
		new ContinueShopping({
			screens: ['SRCH']
		});

		/**
		 * Create global message container
		 */
		new GlobalMessageContainer({container: '#js-messages'});

		/**
		 * Initialize the Mini-Basket extension
		 */
		new MiniBasket({
			closeAfterOpen: true,
			openOnAddToCart: true
		});

		/**
		 * Initialize Inline Form Validations
		 */
		(function initializeHTMLFormValidator () {
			const forms = document.querySelectorAll('.js-form-validator');

			for (let form of forms) {
				form.HTMLFormValidator = new HTMLFormValidatorScrollTop({
					formElement: form,
					wrapperSelector: '.c-form-list__item'
				});
			}
		}());

		/**
		 * Initialize the Dynamic Form-Element Attributes
		 */
		dynamicFormElementAttributes();

		/**
		 * Initialize LazyLoading
		 */
		(() => {
			// Elements
			const lazyLoadElements = document.getElementsByClassName('lazyload');

			if (lazyLoadElements.length === 0) {
				return;
			}

			// Module
			import('lazysizes');
			import('lazysizes/plugins/unveilhooks/ls.unveilhooks');
			import('lazysizes/plugins/bgset/ls.bgset');
			import('lazysizes/plugins/custommedia/ls.custommedia');
		})();

		// Phone Masking
		if (this.pageContext.Store_Code === 'FGAU') {
			const phoneInputs = document.getElementsByClassName('js-phone-mask');
			const mobileInputs = document.getElementsByClassName('js-mobile-mask');
			const postCodeInputs = document.getElementsByClassName('js-postcode-mask');
			if (phoneInputs) {
				for (let input of phoneInputs) {
					new Inputmask({
						mask: '99 9999 9999'
					}).mask(input);
				}
			}
			if (mobileInputs) {
				for (let input of mobileInputs) {
					new Inputmask({
						mask: '9999 999 999'
					}).mask(input);
				}
			}
			if (postCodeInputs) {
				for (let input of postCodeInputs) {
					new Inputmask({
						mask: '9999',
						regex: '^\d*$'
					}).mask(input);
				}
			}
		} else {
			// This is for NZ number masking
			const phoneInputs = document.getElementsByClassName('js-phone-mask');
			const mobileInputs = document.getElementsByClassName('js-mobile-mask');
			const postCodeInputs = document.getElementsByClassName('js-postcode-mask');
			if (phoneInputs) {
				for (let input of phoneInputs) {
					new Inputmask({
						mask: '99 999 9999'
					}).mask(input);
				}
			}
			if (mobileInputs) {
				for (let input of mobileInputs) {
					new Inputmask({
						mask: '999 999 999'
					}).mask(input);
				}
			}
			if (postCodeInputs) {
				for (let input of postCodeInputs) {
					new Inputmask({
						mask: '9999',
						regex: '^\d*$'
					}).mask(input);
				}
			}
		}

		/**
		 * Initialize the Global Top Banner
		 */
		this.initGlobalBanner();

		this.initGTM();
	}

	// eslint-disable-next-line max-lines-per-function
	addedToCart (event) {
		if (!event || !event.detail || !event.detail.formData) {
			return;
		}

		window.dataLayer = window.dataLayer || [];

		if (event.detail.formData?.get?.('Action') === 'ADPM') {
			window.dataLayer.push({
				ecommerce: null
			});

			window.dataLayer.push({
				ecommerce: {
					add: {
						products: [
							{
								/* eslint-disable camelcase */
								item_id: event.detail.formData.get('Products[ 1 ]:code'),
								item_name: event.detail.formData.get('Products[ 1 ]:name'),
								/* eslint-enable camelcase */
								price: parseFloat(event.detail.formData.get('Products[ 1 ]:price') || 0),
								quantity: parseFloat(event.detail.formData.get('Products[ 1 ]:quantity')) || 1
							},
							{
								/* eslint-disable camelcase */
								item_id: event.detail.formData.get('Products[ 2 ]:code'),
								item_name: event.detail.formData.get('Products[ 2 ]:name'),
								/* eslint-enable camelcase */
								price: parseFloat(event.detail.formData.get('Products[ 2 ]:price') || 0),
								quantity: parseFloat(event.detail.formData.get('Products[ 2 ]:quantity')) || 1
							}
						]
					},
					currencyCode: window.mivaJS?.Currency_Code
				},
				event: 'addToCart'
			});
		} else {
			let gtmPrice = parseFloat(event.detail.formData.get('Product_Price') || 0);
			const priceElement = document.getElementById('price-value');
			if (priceElement) {
				gtmPrice = parseFloat(priceElement.innerHTML.replace(/[^0-9.-]+/g, '') || 0);
			}

			window.dataLayer.push({
				ecommerce: null
			});

			window.dataLayer.push({
				ecommerce: {
					add: {
						products: [
							{
								/* eslint-disable camelcase */
								item_id: event.detail.formData.get('Product_Code'),
								item_name: event.detail.formData.get('Product_Name'),
								/* eslint-enable camelcase */
								price: gtmPrice,
								quantity: parseFloat(event.detail.formData.get('Quantity')) || 1
							}
						]
					},
					currencyCode: window.mivaJS?.Currency_Code
				},
				event: 'addToCart'
			});
		}
	}

	initGlobalBanner () {
		const globalBannerElements = document.getElementsByClassName('js-site-top-banner');

		if (!globalBannerElements) {
			return;
		}

		for (const bannerElement of globalBannerElements) {
			this.bindGlobalBannerCloseButton(bannerElement);
		}
	}

	bindGlobalBannerCloseButton (container) {
		const globalBannerCloseElement = container.querySelector('.js-site-top-banner__close');

		if (!globalBannerCloseElement) {
			return;
		}

		const globalBannerActiveId = container.dataset.banner;

		globalBannerCloseElement.addEventListener('click', () => {
			const isHidden = container.classList.contains('u-hidden');

			if (isHidden) {
				return;
			}

			container.classList.add('u-hidden');
			container.setAttribute('aria-hidden', 'true');
			CookieJar.setCookie(`mm5-FGAU-text-banner-${globalBannerActiveId}`, 'dismiss', 120);
		});
	}

	async initModals () {
		const hasModalTrigger = document.querySelector(`[data-micromodal-trigger]`);

		if (!hasModalTrigger) {
			return;
		}

		const {default: Modal} = await import('extensions/modal');
		const modal = new Modal();

		/**
		 * Initialize modals:
		 * 	Pass list of modal ids without an overlay that should close when
		 * 	clicking off of modal.
		 */
		modal.init([
			'js-search-form',
			'js-global-account'
		]);
	}

	async initGTM () {

		const {default: GTM} = await import('extensions/gtm');

		const gtm = new GTM(this.pageContext);
		gtm.init();

		// Listen for Print Events
		window.addEventListener('beforeprint', () => {
			gtm.sendEvent({
				action: 'Click',
				category: 'Print',
				label: document.title,
				noninteractionHit: false
			});
		});
	}
}
